
















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Store } from '@/enums/Store';
import { Locale } from '@/enums/Locale';
import { Currency } from '@/enums/Currency';

import { formatPriceByCurrency } from '@/util/price';

import { namespace } from 'vuex-class';
import { TicketCategory } from '@/util/TicketCategory';
import { Event } from '@/util/Event';

const APP = namespace(Store.APP);

@Component({})
export default class extends Vue {
  @Prop({ required: true }) event!: Event;
  @APP.State('locale') locale!: Locale;
  @APP.State('currency') currency!: Currency;

  paymentIntervals = '';

  created() {
    this.paymentIntervals = this.getPaymentIntervals();
  }

  formatPrice(price: number) {
    return formatPriceByCurrency(price, this.currency);
  }

  get autoDiscountMarketingText() {
    return this.event.ticketCategories[0].autoDiscountMarketingText;
  }

  getPaymentIntervals() {
    const paymentIntervals: string[] = [];
    this.event.ticketCategories.forEach((category: TicketCategory) => {
      if (
        category.paymentInterval &&
        !paymentIntervals.includes(category.paymentInterval)
      ) {
        paymentIntervals.push(category.paymentInterval);
      }
    });

    if (paymentIntervals.length === 1) {
      return this.$t(paymentIntervals[0]).toString();
    }

    const translatedPaymentIntervals: string[] = [];
    paymentIntervals.forEach((paymentInterval) => {
      translatedPaymentIntervals.push(this.$t(paymentInterval + '-adjective').toString());
    });

    return (
      translatedPaymentIntervals.join().replace(/,/g, ', ') + ' ' + this.$t('options')
    );
  }
}
